import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {CommissionCreditsActions} from '../store';
import {CommissionCreditsSelectors} from '../store/selectors';

@Injectable()
export class CommissionCreditsLoadedGuard implements CanActivate {

  constructor(private store$: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.readCommissionCreditsDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  readCommissionCreditsDone(): Observable<boolean> {

    return this.store$.pipe(
      select(CommissionCreditsSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          const params = {
            'order[createdAt]': 'desc'
          };
          this.store$.dispatch(CommissionCreditsActions.ReadCommissionCredits({page: 1, params}));
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
